import { Modal } from 'antd';
import Task from '../../types/Task';
import { BaseButton } from '../UI/BaseButton';
import { TaskType } from '../../types/TaskType';
import { TaskTypeLabel } from '../UI/Dropdown/TaskTypeDropdown';

interface DeleteTasksModalProps {
  tasks?: Task[];
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
  confirmLoading: boolean;
}

export const DeleteTasksModal = (props: DeleteTasksModalProps) => {
  const { open, onCancel, onOk, confirmLoading, tasks } = props;
  return (
    <Modal
      title={
        <div className="text-brand-grey-dark text-base font-semibold mx-4 mt-3">
          You are about to delete the following items:
        </div>
      }
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      centered
      width={640}
      footer={
        <div className="flex justify-end gap-2">
          <BaseButton type="secondary" size="medium" onClick={onCancel}>
            Cancel
          </BaseButton>
          <BaseButton type="primary" size="medium" danger onClick={onOk}>
            Delete Items
          </BaseButton>
        </div>
      }
    >
      {tasks && (
        <div className=" mx-4 mb-10 mt-6 p-3 bg-neutral-200 rounded flex flex-col gap-2 items-center justify-start text-brand-grey-dark text-sm font-medium ">
          {tasks.map((task) => (
            <div key={task.id} className="w-full flex items-center truncate overflow-hidden cursor-default">
              <TaskTypeLabel type={task.type as TaskType} size="small" />
              {task.title}
            </div>
          ))}
        </div>
      )}
      <div className="mx-4 mb-6 text-neutral-900 text-sm font-normal">
        When you delete the tasks, they will no longer be visible in the backlog or sprint. Are you sure you want to
        delete them?
      </div>
    </Modal>
  );
};
